import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";

export const getStatementsRoute = (searchParams) =>
  buildUrl({
    url: `${baseUrl}/payments-loader-api/batches/pageable-search`,
    searchParams,
  });

export const getStatementRoute = (statementId, additionalLineParams, unpaged = true) => {
  let additionalString = `pageable-search?batchIds=${statementId}&unpaged=${unpaged}`;
  Object.entries(additionalLineParams).forEach(([key, values]) => {
    values.forEach((value) => {
      additionalString += `&lines[${key}][accountIds]=${value}`;
    });
  });
  return [`${baseUrl}`, "payments-loader-api", "lines", additionalString].join("/");
};

export const getLineRoute = ({ lineId, addedAccounts }) => {
  const searchParams = addedAccounts.map((accountId) => `accountIds=${accountId}`).join("&");
  return [`${baseUrl}`, "payments-loader-api", "lines", `${lineId}?${searchParams}`].join("/");
};

export const updateLineRoute = (lineId) =>
  [`${baseUrl}`, "payments-loader-api", "lines", `${lineId}`, "retline"].join("/");

export const getProcessBatchRoute = (batchId) =>
  `${baseUrl}/payments-loader-api/batches/${batchId}/process`;

export const getUploadBatchRoute = (currencyId, batchDate, unpaged = true) =>
  `${baseUrl}/payments-loader-api/batches/upload?currencyId=${currencyId}&batchDate=${batchDate}&unpaged=${unpaged}`;

export const deleteBatchRoute = (batchId) => `${baseUrl}/payments-loader-api/batches/${batchId}`;
